import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { SnCamera } from '@lib/api/entities';
import { SnCamerasAPI } from '@lib/api/services';
import { GoogleMap, GoogleMapPopup } from '@lib/geo/google/map';
import { SnTitleService } from '@lib/state/title';
import { t } from '@lib/translation/helpers/translation.helper';

import { SentryCameraDialogComponent } from '../components/sentry-camera-dialog/sentry-camera-dialog.component';
import { SentryCameraPopupComponent } from '../components/sentry-camera-popup/sentry-camera-popup.component';

@Injectable({
  providedIn: 'root',
})
export class MapSentrySearchService {
  private _map: GoogleMap;
  private _selectedPopup: GoogleMapPopup;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _toastrService: ToastrService,
    private readonly _camerasAPI: SnCamerasAPI,
    private readonly _router: Router,
    private readonly _titleService: SnTitleService,
    private readonly _dialog: MatDialog,
  ) {}

  public onMapLoaded(googleMap: GoogleMap): void {
    this._map = googleMap;
  }

  public getCameraAndGoTo(item: any, data: any, queryParams: any): any {
    this._camerasAPI
      .getCamera(item.cameraId)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (camera) => {
          this.goToCamera(camera, item, data, queryParams);
        },
        error: () => {
          this._toastrService.error(t('common.cameraSnapshotUnavailable'));
        },
      });
  }

  public goToCamera(camera: SnCamera, item: any, data: any, queryParams: any): void {
    if (
      this._router.routerState.snapshot.url?.toString()?.toLowerCase()?.includes('/map') &&
      this._titleService.getTitle() === 'Map'
    ) {
      const popup = new GoogleMapPopup(SentryCameraPopupComponent, {
        data: {
          camera,
          item,
          queryParams,
          snapshot: item.detectionsImageUrl,
          resolution: item.resolution,
          aiBox: data.box,
          meta: item.detectionsFiltered[0],
        },
        lonLat: camera.geometry.coordinates,
        disableAutoPan: false,
        pixelOffset: new google.maps.Size(0, -12, 'pixel', 'pixel'),
      });
      popup.open(this._map);
      this._map.setCenter(camera.geometry.coordinates);
      if (this._selectedPopup) {
        this._selectedPopup.close();
      }
      this._selectedPopup = popup;
    } else {
      this._dialog.open(SentryCameraDialogComponent, {
        data: {
          camera,
          item,
          queryParams,
          snapshot: item.detectionsImageUrl,
          resolution: item.resolution,
          aiBox: data.box,
        },
        minWidth: '50vw',
      });
    }
  }
}
